import styled from "styled-components";

export const Container = styled.div`
  margin-bottom: 7px;
  background: linear-gradient(180deg, #f3ede4 0%, #ffffff 100%);
  .speed-text {
    .MuiTab-wrapper {
      font-weight: 600;
      font-size: 12px;
      line-height: 14px;
      color: var(--theme-text);
      text-transform: capitalize;
      background: var(--text-primary);
      border: 1px solid #0f0f0f;
      border-radius: 5px;
      padding: 5px;
      width: auto;
    }
  }
  .MuiTabs-indicator {
    display: none;
  }
  .MuiTab-root {
    min-width: auto;
    flex: 1;
    background-color: transparent;
    opacity: 1;
    border-right: 1px solid #0000001a;
  }
  .last-btn {
    border: none;
  }
  .MuiTab-textColorInherit.Mui-selected {
    background-color: #e4eef9;
  }
  .MuiTab-textColorInherit.Mui-selected1 {
    background-color: #ffffff;
  }
  .stage-car {
    /* margin-right: 150px; */
   
  }
  .stage-button {
    font-size: 14px;
    line-height: 150.5%;
    padding: 5px 10px;
    border: 1px solid #636f7c;
    border-radius: 30px;
    background-color: transparent;
  }
  .normal {
    background: #ffffff;
  }
  .MuiAppBar-root {
    box-shadow: none;
    border-radius: 6px 6px 0 0;
    overflow: hidden;
    background-color: transparent;
  }
  
  .MuiBox-root {
    background: #fffcfa;
    box-shadow: 0px 4px 4px rgb(0 0 0 / 25%);
    border-radius: 0 0 6px 6px;
  }
  .MuiCheckbox-root {
    margin-right: 6px;
  }
`;

export const TabWrapper = styled.div`
  .lock-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width:100%;
    .stage-btn-wrapper {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    span {
      font-weight: 700;
      font-size: 14px;
      line-height: 150.5%;
      display: flex;
      align-items: center;
      gap: 7px;
    }
  }
  .fleet-car-wrapper {

    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    
    .inner-btn {
      display: flex;
      gap: 10px;
      > .MuiFormControlLabel-root {
      margin-right: 0;
    }
    }
    .select {
      /* width: 100%; */

      .MuiFormControl-root {
        width: 100%;
        margin: 0;
      }
      .MuiInputBase-sizeSmall {
        background: #ffffff;
        border: 1px solid #cdcfd0;
        border-radius: 6px;
        white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 164px;
      }
      .MuiInputBase-inputSizeSmall {
        padding: 3.5px 14px;
        padding-right: 32px;
      }
    }
    button {
      font-size: 13px;
      line-height: 150.5%;
      padding: 5px 14px;
      border: 1px solid #636f7c;
      border-radius: 30px;
      background-color: transparent;
      text-transform: capitalize;
      color: inherit;
    font-weight: normal;
    &.active {
          background: #bc9b6a;
    color: #fff;
    border-color: transparent;
    }
    &.disabled{
      pointer-events: none;
      cursor: default;
      color: rgba(0, 0, 0, 0.26);
    }
    }
    @media(max-width: 410px) {
      &.for-enable-car {
        display: grid;
        width: 100%;
        > div {
          :last-child {
            justify-self: flex-end;
          }
        }
      }
    }
  }
`;
